import { useMutation } from '@tanstack/react-query'

import { pqClient } from '@/features/prequalification/localControl/endpoints/pqClient'
import type { UseMutationOptions } from '@/types/queries'

export type UseRemoveResourceSetResourceMutationParams = {
  resourceSetId: string
}

export function useRemoveResourceSetResourceMutation(
  params: UseRemoveResourceSetResourceMutationParams,
  options?: UseMutationOptions<void, string>,
) {
  const { mutateAsync, ...mutationResult } = useMutation({
    ...options,
    mutationFn: (resourceId: string) => pqClient.removeResourceSetResource(params.resourceSetId, resourceId),
  })

  return { removeResourceSetResource: mutateAsync, ...mutationResult }
}
